module.exports = __webpack_public_path__ + "static/media/SarahSwitek_08_EnergyLevel-Confirmation_4.429b077d.mp3";